<script>
import appConfig from "@/app.config";
import { notificationMethods } from "@/state/helpers";
import Offline from '@/components/widgets/offline'

export default {
  name: "app",
  data(){
    return {
      online: true,
    }
  },
  components:{
    Offline
  },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();
    },
  },
  methods: {
    clearNotification: notificationMethods.clear,
    amIOnline(e) {
      this.online = e
    },
  }
};
</script>

<template>
  <div id="app">
    <v-offline
      @detected-condition="amIOnline"
      online-class="online"
      offline-class="offline"
    >
      <template v-if="online">
        <RouterView />
      </template>
      <template v-if="!online">
        <offline />
      </template>
    </v-offline>
  </div>
</template>
